class CustomFeatureGridReveal {
  constructor(grid) {
    this.grid =
      grid;

    this.cards =
      Array.from(
        grid.querySelectorAll(
          '[data-custom-feature-card]'
        )
      );

    if (!this.cards.length) {
      return;
    }

    this.initialize();
  }


  initialize() {
    /*
     * Accessibility preference.
     */
    if (
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
    ) {

      this.revealAll();

      return;
    }


    /*
     * Progressive enhancement:
     * cards are visible unless JS confirms
     * IntersectionObserver support.
     */
    if (
      !(
        'IntersectionObserver'
        in window
      )
    ) {

      this.revealAll();

      return;
    }


    this.cards.forEach(card => {

      card.classList.add(
        'is-reveal-pending'
      );

    });


    this.observer =
      new IntersectionObserver(
        entries => {

          entries.forEach(
            entry => {

              if (
                !entry.isIntersecting
              ) {
                return;
              }


              entry.target.classList.remove(
                'is-reveal-pending'
              );


              entry.target.classList.add(
                'is-revealed'
              );


              this.observer.unobserve(
                entry.target
              );

            }
          );

        },
        {
          threshold: 0.12,

          rootMargin:
            '0px 0px -7% 0px'
        }
      );


    this.cards.forEach(card => {

      this.observer.observe(
        card
      );

    });
  }


  revealAll() {
    this.cards.forEach(card => {

      card.classList.remove(
        'is-reveal-pending'
      );


      card.classList.add(
        'is-revealed'
      );

    });
  }
}


function initializeCustomFeatureGrids(
  root = document
) {

  root
    .querySelectorAll(
      '[data-custom-feature-grid]'
    )
    .forEach(grid => {

      if (
        grid.dataset.revealInitialized ===
        'true'
      ) {
        return;
      }


      grid.dataset.revealInitialized =
        'true';


      new CustomFeatureGridReveal(
        grid
      );

    });
}


if (
  document.readyState ===
  'loading'
) {

  document.addEventListener(
    'DOMContentLoaded',
    () => {

      initializeCustomFeatureGrids();

    }
  );

} else {

  initializeCustomFeatureGrids();

}


/*
 * Shopify Theme Editor:
 * reinitialize when a section is added
 * or rerendered.
 */

document.addEventListener(
  'shopify:section:load',
  event => {

    initializeCustomFeatureGrids(
      event.target
    );

  }
);